module.exports = __webpack_public_path__ + "static/media/TN-Men-Knit-v2.0.d1d4a670.svg";